module.exports = __webpack_public_path__ + "static/media/chinese-cyclists.3837fa0f.jpg";